import { Component, OnInit } from '@angular/core';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { GamificationService } from '../services/gamification.service';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';

@Component({
  selector: '',
  template: '',
})
export class GamificationInquiryHandler extends BaseSearchComponent<GamificationService> implements OnInit {
  private fullPath;
  private labelKey;
  public searchName: string;
  headers = [];
  filteredData = [];

  constructor(
    public service: GamificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    this.searchName = 'SearchGamification';
  }

  ngOnInit() {
    const pathSegments = this.route.snapshot.url;
    this.fullPath = pathSegments.map((segment) => segment.path).join('/');
    const inputLabel = this.fullPath.split('-')[0];
    this.labelKey = inputLabel.charAt(0).toUpperCase() + inputLabel.slice(1);
    this.getBreadCrumbList();
    this.getSearchList();
    super.ngOnInit();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: this.labelKey + ' ' + this.settingService.getLabelValue('gamificationInquiry'),
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.labelKey + ' ' + this.settingService.getLabelValue('gamificationInquiry');
    return header;
  }

  isNumeric(value: any): boolean {
    return value !== null && value !== '' && !isNaN(+value);
  }

  formatNumber(value: any): string {
    if (value === null || value === '' || isNaN(value)) return value;

    const numberValue = +value;

    if (Number.isInteger(numberValue)) {
      return numberValue.toLocaleString('en-IN');
    }

    return numberValue.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  getSearchList() {
    this.service.getSearchList(this.searchName).subscribe(
      (response: any) => {
        const jsonData = response?.data?.searchResultInfo || {};
        const searchResultData = response?.data?.searchResultData || [];
        const fields = Object.values(jsonData)
          .filter((item: any) => item.LABELKEY && item.position != null)
          .sort((a: any, b: any) => a.position - b.position);

        const labelKeys = fields
          .filter((item: any) => item.LABELKEY !== 'evaluationId')
          .map((item: any) => item.LABELKEY);
        this.headers = [...labelKeys];
        this.filteredData = searchResultData.map((row: any[]) => {
          const rowObj: any = {};
          fields.forEach((field, index) => {
            rowObj[field['LABELKEY']] = row[index];
          });
          return rowObj;
        });
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  openDetail(row: any) {
    this.router.navigate(['/' + this.labelKey.toLowerCase() + '-request/' + row.gamificationrequestseq]);
  }

  openResult(row: any) {
    this.router.navigate(['/' + this.labelKey.toLowerCase() + '-result/' + row.evaluationId]);
  }
}
